module.exports = __webpack_public_path__ + "static/media/wn8.5bdb5375.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/wn8.png
// module id = 215
// module chunks = 0